"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TronConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const Utils_1 = require("../Utils");
const TronLinkConnector_1 = require("./Connectors/Wallets/TronLinkConnector");
const Factory_1 = require("./Connectors/Factory");
const Utils_2 = require("../../Connectors/Utils");
const _1 = require(".");
const tronGridApiKey = "a2a267ee-3e71-430c-b51a-342aabd68deb";
exports.TronConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.Tron,
    chainId: Types_1.EthChainIds.Tron,
    publicRpc: "https://api.trongrid.io",
    nativeToken: Tokens_1.TronNativeToken,
    wrappedToken: _1.TronWrappedToken,
    upToken: _1.TronUpToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmNfhQcEHNL7tJJHCitHEwKFEr37dLJPVWaWZ13yXbYUZ8",
    connectorFactory: Factory_1.tronConnectorFactory,
    multicall: {
        supported: true,
    },
    explorer: {
        baseUrl: "https://tronscan.org",
        address: function (address) {
            return `${this.baseUrl}/#/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/#/token20/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/#/transaction/${address}`;
        },
    },
}, [TronLinkConnector_1.TronLinkConnector], [
    Factory_1.createTronOfflineConnectorHelper(Types_1.OfflineConnectors.TronGrid, {
        fullHost: "https://api.trongrid.io",
        headers: { "TRON-PRO-API-KEY": tronGridApiKey },
    }),
    Factory_1.createTronOfflineConnectorHelper(Types_1.OfflineConnectors.UnifiProxy, {
        fullHost: Utils_2.unifiBlockchainProxyUrl(Types_1.Blockchains.Tron),
    }),
]);
